import { useEffect } from 'react';
import { store } from '../..';
import { lookupActionCreators, OnDemandLookupTypes } from '../../ducks/lookups';
import { getNonLoadedOrLoadingLookups } from '../../ducks/lookups/lookupsSelectors';

export const useLookups = (types: OnDemandLookupTypes[]) => {
  useEffect(() => {
    const state = store.getState();
    const notLoaded = getNonLoadedOrLoadingLookups(state, types);

    if (notLoaded.length > 0) {
      store.dispatch(lookupActionCreators.fetchOnDemandLookups(notLoaded));
    }
  }, []);
};
